import { RootState } from 'store';
import { OkrPendingKeyResult } from './interfaces';

export const selectPendingKeyResults = (state: RootState) =>
  state.okrPendingKeyResults.items as OkrPendingKeyResult[];

export const selectReviewCycleById = (state: RootState, id: string) =>
  selectPendingKeyResults(state).find((item) => item.id === Number(id));
